import React from "react";
import LoaderImg from "../../assets/images/Genius-sun-loader.gif";
import "./style.scss";
import { useDispatch, useSelector } from "react-redux";
import { getRequestAPIState, terminateRequest } from "../../redux/slices/requestSlice";
import { setActivityIndicator } from "../../redux/slices/appconfigSlice";
import useTranslationCustom from "../../i18n/customHook/useTranslation";

const Loader = () => {
    const dispatch = useDispatch();
    const { T } = useTranslationCustom();
    const { apiLoading, apiUrl } = useSelector(getRequestAPIState);

    const handleCancelRequest = async () => {

        // if (apiUrl?.includes('/SearchOnlyListing')) {
        //     // For SearchOnlyListing: clear GUID and restart search
        //     const _params = { ...apiParams, GUID: "", page: 1 };

        //     // Dispatch terminateRequest first to cancel the ongoing request
        //     dispatch(terminateRequest());

        //     // Wait a bit for cancellation to complete before making new request
        //     await new Promise(resolve => setTimeout(resolve, 100));

        //     const isValidSearch = (data) => {
        //         return (
        //             data &&
        //             Array.isArray(data.FlightSegmentList) &&
        //             data.FlightSegmentList.length >= 2 &&
        //             data.FlightSegmentList[0]?.Departure?.CodeList &&
        //             data.FlightSegmentList[0]?.Arrival?.CodeList &&
        //             data.FlightSegmentList[1]?.Departure?.Date &&
        //             Array.isArray(data.PassengerAgeRoomItemList) &&
        //             data.PassengerAgeRoomItemList.length > 0
        //         );
        //     };

        //     if (isValidSearch(_params)) {
        //         await dispatch(getHotels({ params: _params, T, dispatch, shouldAddToSearchHistory: false }));
        //     }

        //     return;
        // }

        // For other requests: just cancel and stop loading
        dispatch(terminateRequest());
        dispatch(setActivityIndicator(false)); // Ensure activity indicator is also turned off
    };

    return (
        <div className="loader show">
            {apiLoading && (
                <div className='reset-btn' onClick={handleCancelRequest}>{T('Buttons:Reset')}</div>
            )}
            <div className="loader-content">
                <img src={LoaderImg} className={'loader_spinner'} alt={'loading-image'} />
                <p>{T("Common:Loading")} ...</p>

                {apiUrl?.includes('/SearchOnlyListing') && (
                    <p className={'mt-3'}>{T('Common:Loading_Screen_Banner')}</p>
                )}
            </div>
        </div>
    );
};

export default Loader;
